module.exports = __webpack_public_path__ + "mobile/img/icon_home_nav_logo3.31f26bba.png";